import { useEffect, useState, useRef, useMemo } from "react";

import "./styles.css";

import { useParams } from "react-router-dom";
import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";

import { useScreen } from 'Screen/ScreenContext';

import Player from './components/Player'
import AutoplayToggle from './components/AutoplayToggle'
import { UserAvatar } from "@components/Community";
import { CommunityBanner } from "@components/Community";
import { AddRounded, ArrowDownward, ArrowDropDownRounded, CheckCircleRounded, CommentRounded, KeyboardArrowDownRounded, SendRounded, SlowMotionVideoRounded, MoreVertRounded, DeleteRounded, ReplyRounded, AttachmentRounded, AttachFileRounded, LockRounded, ShareRounded, KeyboardArrowRightRounded } from "@mui/icons-material";
import Popper from "@fragments/Popper";
import parser from "@helpers/parser";
import { useAuth } from "@contexts/AuthContext";
import { sendMessageTo } from "Screen/ChatPanel/ChatPanelContext";
import { CircularProgress, Divider, Skeleton } from "@mui/material";

import { Button, Text } from "@fragments";

import videoHelpers from "@helpers/video.js";

import { ReactComponent as PremiumIcon } from '@assets/custom-icons/premium.svg'




// Componente de loading com 5 itens usando Material Skeleton
function CardLoading() {
    return (
        <div className="card-loading-container">
            {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="card-loading-item">
                    <div className="card-loading-header">
                        <Skeleton
                            variant="circular"
                            width={40}
                            height={40}
                            className="card-loading-avatar"
                        />
                        <div className="card-loading-user-info">
                            <Skeleton
                                variant="text"
                                width={120}
                                height={20}
                                className="card-loading-username"
                            />
                            <Skeleton
                                variant="text"
                                width={80}
                                height={16}
                                className="card-loading-timestamp"
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default function Content() {
    let { slug, section: sectionId, content: contentId } = useParams();

    const { loading: communityLoading } = useCommunity();
    const { setFullWidth, setBreadcrumb } = useScreen();

    useEffect(() => {
        setFullWidth(true);
        return () => setFullWidth(false);
    }, [setFullWidth]);

    const [lesson, setLesson] = useState({});
    const [course, setCourse] = useState({});

    useEffect(() => {
        setBreadcrumb([
            { label: course?.name, href: course?.id ? `/${slug}/section/${course?.id}` : undefined },
            { label: lesson?.name },
        ]);
        return () => setBreadcrumb(null);
    }, [course?.name, course?.id, lesson?.name, slug]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loading && !communityLoading) {
            handleLoadContent();
        }
    }, [loading, communityLoading]);

    useEffect(() => {
        if (!loading) setLoading(true);
    }, [contentId]);

    async function handleLoadContent() {
        try {
            const { data } = await api.get(`content/${contentId}`);
            setLesson({ ...data });
            handleLoadCourse(data.section)
            console.log(data);
        } catch (e) {
            console.log(e);
        }

        setLoading(false);
    }

    async function handleLoadCourse(course) {
        try {
            const { data } = await api.get("section/" + course);
            setCourse({ ...data });
            console.log(data);
        } catch (e) {
            console.log(e);
        }

        setLoading(false);
    }

    const currentPlaylist = useMemo(
        () => course?.content?.filter(p => p.id == lesson?.playlist)[0],
        [course?.content, lesson?.playlist]
    );

    const nextContent = useMemo(() => {
        if (lesson?.single) return null;
        const contents = currentPlaylist?.contents;
        if (!contents?.length || !lesson?.id) return null;
        const idx = contents.findIndex(c => c.id == lesson.id);
        if (idx < 0 || idx >= contents.length - 1) return null;
        return contents[idx + 1];
    }, [currentPlaylist, lesson?.id, lesson?.single]);

    const handleAutoplayNext = (content) => {
        if (!content) return;
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/');
        const sectionIndex = pathParts.indexOf('section');
        const newPath = pathParts.slice(0, sectionIndex + 1).join('/')
            + `/${content.section}/${content.id}`;
        window.navigate(newPath);
    };

    const MEMO_sugestions = useMemo(() => {
        return (
            <ContentSuggestions
                key={lesson?.id + course?.id}
                module={currentPlaylist}
                course={course}
                lesson={lesson}
            />
        )
    }, [lesson?.id, course?.id]);

    console.log('lesson', lesson)

    return (
        <div className="content-page pb-8">
            <div className="content-container mt-2">
                <div className={"content-video " + (lesson?.video?.aspect_ratio < 1 ? 'vertical' : 'horizontal')}>
                    <Player
                        info={lesson}
                        key={lesson?.id}
                        nextContent={nextContent}
                        onAutoplayNext={handleAutoplayNext}
                    />
                    <div className="content-info-description mt-3">
                        <Text.h2 weight={500} className="content-title mb-1">{lesson?.name}</Text.h2>
                        <CreatorInfo lesson={lesson} />
                        <Description lesson={lesson} />
                        <CommentsSection lesson={lesson} />
                    </div>
                </div>
                {MEMO_sugestions}
            </div>
        </div>
    );
}

function CreatorInfo({ lesson }) {
    const { community, communityManagement } = useCommunity();
    const currentCommunity = community?.get(lesson?.community);

    const [loading, setLoading] = useState(false);
    const [subscribed, setSubscribed] = useState(['creator', 'owner', 'member'].includes(currentCommunity?.role));


    useEffect(() => {
        setSubscribed(['creator', 'owner', 'member'].includes(currentCommunity?.role));
    }, [currentCommunity?.role]);

    async function handleSubscribeClick() {
        setLoading(true);
        await community.subscribe(currentCommunity.id, () => {
            setSubscribed(true);
        });
        setLoading(false);
    }

    async function handleUnsubscribeClick() {
        setLoading(true);
        await community.unsubscribe(currentCommunity.id, () => {
            setSubscribed(false);
        });
        setLoading(false);
    }

    function handleShareContentClick() {
        window.handleOpenShareContentModal?.({
            title: lesson?.name || "Compartilhar conteúdo",
            link: window.location.href,
        });
    }

    if (!lesson?.creator) return null;

    return (
        <div className="creator-info">
            <div className="video-actions-row">
                <UserAvatar user={lesson?.creator} size={44} displayName={true} displayNickname={true} />

                <KeyboardArrowRightRounded style={{transform: 'translateX(-3px)'}}/>

                <div className="community-block">
                    <CommunityBanner banner={currentCommunity?.banner} size={38}/>

                    <div className="community-name-block">
                        <Text.h5 weight={500}>{currentCommunity?.name}</Text.h5>
                        <Text.small contrast={6}>{currentCommunity?.members?.total || 0} membros</Text.small>
                    </div>

                    {
                        subscribed && currentCommunity?.role !== 'creator' && <Button
                            tooltip="Gerenciar inscrição"
                            size="small"
                            color="white"
                            loading={loading}
                            endIcon={<ArrowDropDownRounded />}
                            onClick={handleUnsubscribeClick}
                        >
                            Inscrito
                        </Button>
                    }

                    {
                        !subscribed && currentCommunity?.role !== 'creator' && <Button
                            tooltip="Se inscrever"
                            size="small"
                            color="white"
                            loading={loading}
                            onClick={handleSubscribeClick}
                        >
                            Se inscrever
                        </Button>
                    }
                </div>
            </div>
            <div className="video-actions-row">
                <Button
                    tooltip="Enviar vídeo para um amigo"
                    size="medium"
                    color="overlay"
                    endIcon={<ShareRounded />}
                    onClick={handleShareContentClick}
                >
                    Compartilhar
                </Button>
            </div>


        </div>
    )
}

function Attachments({ lesson }) {

    if (!lesson?.attachments?.length) return null;

    function ensureValidUrl(url) {
        if (!url) return '#';

        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }

        return `https://${url}`;
    }

    return (
        <div className="attachments-container">
            <Text.h4 className="mt-3 mb-1" value="Links disponíveis" icon={<AttachmentRounded />} />
            <div className="attachments-list">
                {lesson?.attachments?.map((attachment, index) => (
                    <a
                        key={index}
                        href={lesson?.availability?.available ? ensureValidUrl(attachment.url) : '#'}
                        target={lesson?.availability?.available ? '_blank' : ''}
                        rel="noopener noreferrer"
                        className={"pressable attachment-item bsf-8 " + (lesson?.availability?.available ? '' : ' disabled')}
                    >
                        {
                            !lesson?.availability?.available && <LockRounded style={{ fontSize: 18 }} />
                        }
                        <span className="attachment-text">{attachment.text || attachment.name || attachment.title}</span>
                        <AttachFileRounded style={{ fontSize: 18 }} />
                    </a>
                ))}
            </div>
        </div>
    )
}

function Description({ lesson }) {
    return (
        <div className="content-description-block mt-2">
            <small className="pb-2">{lesson?.views || 0} views • publicado a {parser.date.ago(lesson?.timestamps?.created)}</small>

            {lesson?.description?.split('\n').map((line, index) => (
                <h5 className="content-description mt-1" key={index}>{line}</h5>
            ))}

            <Attachments lesson={lesson} />
        </div>
    )
}

function ContentSuggestions({ module, course, lesson }) {
    const [info, setInfo] = useState(module);


    const [selectedId, setSelectedId] = useState(lesson?.id);

    const popperRef = useRef();

    function handleOpenContent(content) {
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/');
        const sectionIndex = pathParts.indexOf('section');

        const newPath = pathParts.slice(0, sectionIndex + 1).join('/') +
            `/${content?.section}/${content.id}`;
        window.navigate(newPath);
    }

    function handleModuleSelect(event) {
        if (!course?.content) return;

        // Filtrar apenas módulos
        const modules = course.content.filter(item => item.contents?.length);

        const options = modules.map(module => ({
            id: module.id,
            label: module.name,
            onClick: async () => {
                setInfo(module);
                popperRef.current.close();
            }
        }));

        popperRef.current.open(options, 'bottom', event.currentTarget);
    }


    function ContentCard({ content }) {
        const [thumb, setThumb] = useState(content?.banner || null);
        const isHorizontal = content?.video?.aspect_ratio > 1;

        // Gerar thumbnail se não existir
        useEffect(() => {
            if (content?.banner || !content?.video?.src) return;

            createFallbackThumb()
        }, [content]);


        async function createFallbackThumb() {
            const thumb = await videoHelpers.generateThumbFromVideo(content.video.src);
            setThumb(thumb)
        }

        return (
            <div className={
                "content-card mt-1 "
                + (isHorizontal ? 'horizontal' : 'vertical')
                + ' ' + (selectedId === content.id ? 'active' : '')
            } onClick={() => {
                setSelectedId(content.id)
                handleOpenContent(content)
            }}>
                <div className="content-card-banner" style={{
                    aspectRatio: content?.aspect_ratio,
                    maxWidth: isHorizontal ? 'unset' : '60px',
                }}>
                    {thumb && <img src={thumb} alt={content?.name} />}

                    <PlayCircleOutlineRoundedIcon className="content-card-play-icon" color="white" />
                </div>

                <div className="content-card-info">
                    <Text.h5 weight={400} maxLines={2} contrast={8} left={
                        content.watched ? <CheckCircleRounded
                            style={{ fontSize: 16, marginRight: 4, transform: 'translateY(-1px)' }}
                        /> : null
                    }>
                        {content?.name}
                    </Text.h5>

                    <div className="content-creation-info">
                        <UserAvatar user={content?.creator} size={19} displayName={true} />
                    </div>
                </div>

                {!content?.availability?.available && (
                    <span className="content-card-premium-icon-container">
                        <small>Premium</small>
                        <PremiumIcon className="content-card-premium-icon" />
                    </span>
                )}
            </div>
        );
    }

    function CurrentModule() {
        return (
            <div className={"current-module " + (!info?.banner && 'pl-2')} onClick={handleModuleSelect}>
                {
                    info?.banner ? <img src={info?.banner} className="current-module-banner" /> : null
                }
                <div className="current-module-title">
                    <div className="current-module-header">
                        <SlowMotionVideoRounded
                            style={{
                                fontSize: 16,
                                transform: 'translateY(-2px)',
                                marginRight: '0px',
                                marginTop: '-2px'
                            }}
                            className="csf-4"
                        />
                        <Text.h5 weight={400} contrast={7}>
                            {lesson?.single ? 'VÍDEO AVULSO' : 'PLAYLIST ATUAL'} - {lesson?.single ? '1 vídeo' : (info?.content?.length || 0) + ' vídeos'}
                        </Text.h5>
                    </div>
                    <Text.h4 weight={400} contrast={8}>{lesson?.single ? lesson?.name : info?.name}</Text.h4>

                </div>
                <KeyboardArrowDownRounded className="current-module-arrow" />
            </div >
        )
    }

    return (
        <div className="content-sugestions" key={info?.id}>
            {<CurrentModule />}

            {
                !lesson?.single && <AutoplayToggle />
            }

            {
                !lesson?.single && <h3 className="content-suggestions-title mt-3 mb-1 bold">Mais conteúdos nesta playlist</h3>
            }

            {
                !lesson?.single && info?.contents?.map((content, index) => (
                    <ContentCard key={index} content={content} />
                ))
            }

            {
                !info && !lesson?.single && <CardLoading />
            }

            {
                !lesson?.single && <Popper controlRef={popperRef} />
            }
        </div>
    )
}

function CommentsSection({ lesson }) {
    const { user } = useAuth();
    const [comments, setComments] = useState([]);
    const [loadingComments, setLoadingComments] = useState(false);
    const [replyingTo, setReplyingTo] = useState(null);
    const popperRef = useRef();

    const loadComments = async () => {
        if (!lesson?.id) return;

        setLoadingComments(true);
        try {
            const { data } = await api.get(`content/comment/${lesson.id}`);

            console.log('comments', data)

            setComments(data || []);
        } catch (error) {
            console.error('Error loading comments:', error);
            window.setSnackbar('Erro ao carregar comentários', 'error');
        } finally {
            setLoadingComments(false);
        }
    };

    useEffect(() => {
        loadComments();
    }, [lesson?.id]);

    const handleCommentAction = (event, comment, isChild = false) => {
        const options = [];

        // Reply option (only for root comments, not sub-comments)
        if (!isChild) {
            options.push({
                id: 'reply',
                label: 'Responder',
                icon: <ReplyRounded style={{ fontSize: 16 }} />,
                onClick: () => {
                    setReplyingTo(replyingTo === comment.id ? null : comment.id);
                    popperRef.current.close();
                }
            });
        }

        // Send message option (only if comment owner is different from logged user)
        if (comment.user?.id !== user?.id) {
            options.push({
                id: 'message',
                label: 'Enviar mensagem',
                icon: <SendRounded style={{ fontSize: 16 }} />,
                onClick: () => {
                    sendMessageTo(comment.user);
                    popperRef.current.close();
                }
            });
        }

        // Delete option (only if comment owner is the logged user)
        if (comment.user?.id === user?.id) {
            options.push({
                id: 'delete',
                label: 'Excluir',
                icon: <DeleteRounded style={{ fontSize: 16 }} />,
                variant: 'delete',
                onClick: async () => {
                    try {
                        await api.delete(`content/comment/${comment.id}`);
                        window.setSnackbar('Comentário excluído com sucesso!', 'success');
                        loadComments();
                    } catch (error) {
                        console.error('Error deleting comment:', error);
                        window.setSnackbar('Erro ao excluir comentário', 'error');
                    }
                    popperRef.current.close();
                }
            });
        }

        popperRef.current.open(options, 'bottom', event.currentTarget);
    };

    function AddComment({ replyTo = null, onCancel = null }) {
        const [inputValue, setInputValue] = useState('');
        const [isLoading, setIsLoading] = useState(false);
        const textareaRef = useRef(null);

        const adjustTextareaHeight = () => {
            const textarea = textareaRef.current;
            if (textarea) {
                // Reset height to auto to get the natural height
                textarea.style.height = 'auto';

                // Calculate the new height, but ensure it's at least the minimum
                const newHeight = Math.max(textarea.scrollHeight, 42);
                const finalHeight = Math.min(newHeight, 120);

                textarea.style.height = finalHeight + 'px';

                // Only show scrollbar if content exceeds max height
                if (textarea.scrollHeight > 120) {
                    textarea.style.overflowY = 'auto';
                } else {
                    textarea.style.overflowY = 'hidden';
                }
            }
        };

        const handleInputChange = (e) => {
            setInputValue(e.target.value);
            adjustTextareaHeight();
        };

        const handleSubmit = async () => {
            const trimmedValue = inputValue.trim();

            // Validation
            if (trimmedValue.length < 3) {
                window.setSnackbar('Comentário deve ter pelo menos 3 caracteres', 'error');
                return;
            }

            if (trimmedValue.length > 500) {
                window.setSnackbar('Comentário deve ter no máximo 500 caracteres', 'error');
                return;
            }

            setIsLoading(true);

            try {
                const payload = {
                    content: lesson.id,
                    text: trimmedValue
                };

                // Add answer_of parameter if this is a reply
                if (replyTo) {
                    payload.answer_of = replyTo;
                }

                await api.post('content/comment', payload);

                setInputValue('');
                adjustTextareaHeight();
                window.setSnackbar('Comentário publicado com sucesso!', 'success');

                // Reload comments after successful post
                loadComments();

                // If this was a reply, close the reply form
                if (replyTo && onCancel) {
                    onCancel();
                }
            } catch (error) {
                console.error('Error posting comment:', error);
                window.setSnackbar('Erro ao publicar comentário', 'error');
            } finally {
                setIsLoading(false);
            }
        };

        const handleKeyPress = (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit();
            }
        };

        // Focus the textarea when component mounts (for replies)
        useEffect(() => {
            if (replyTo && textareaRef.current) {
                textareaRef.current.focus();
            }
        }, [replyTo]);

        // Adjust height when inputValue changes
        useEffect(() => {
            adjustTextareaHeight();
        }, [inputValue]);

        return (
            <div className="add-comment-container mt-2 mb-3">
                <UserAvatar user={user} size={32} />

                <div className="add-comment-input-container">
                    <textarea
                        ref={textareaRef}
                        placeholder={replyTo ? "Responder ao comentário..." : "Adicione um comentário"}
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading}
                        rows={1}
                        className="comment-textarea"
                    />
                </div>

                {inputValue.length > 3 ? (
                    <button
                        className="add-comment-submit"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading && <CircularProgress size={16} />}
                        <span>{replyTo ? 'Responder' : 'Publicar'}</span>
                        <SendRounded style={{ fontSize: 16 }} />
                    </button>
                ) : <div className="add-comment-plus">
                    <AddRounded />
                </div>}
            </div>
        )
    }

    function CommentsList() {
        if (loadingComments) {
            return (
                <div className="comments-loading">
                    <CircularProgress size={24} style={{ color: 'white' }} />
                    <span>Carregando comentários...</span>
                </div>
            );
        }

        if (comments.length === 0) {
            return (
                <div className="comments-empty">
                    <span>Nenhum comentário ainda. Seja o primeiro a comentar!</span>
                </div>
            );
        }

        const renderComment = (comment, isChild = false) => (
            <div key={comment.id} className={isChild ? "comment-child" : ""}>
                <div className="comment-item">
                    <UserAvatar user={comment.user} size={32} />
                    <div className="comment-content">
                        <div className="comment-header">
                            <span className="comment-author bold">{comment.user?.username || 'Usuário'}</span>
                            <span className="comment-date">•{"  "} {parser.date.ago(comment.timestamps?.created)}</span>

                            <span
                                className="pressable comment-menu-button"
                                onClick={(e) => handleCommentAction(e, comment, isChild)}
                            >
                                <MoreVertRounded style={{ fontSize: 18 }} />
                            </span>
                        </div>
                        <span className="comment-text">{comment.comment}</span>
                        {!isChild && (
                            <div className="comment-actions">
                                <span
                                    className="pressable answer-button"
                                    onClick={() => setReplyingTo(replyingTo === comment.id ? null : comment.id)}
                                >
                                    Responder
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Reply form - only for root comments */}
                {!isChild && replyingTo === comment.id && (
                    <div className="comment-reply">
                        <AddComment
                            replyTo={comment.id}
                            onCancel={() => setReplyingTo(null)}
                        />
                    </div>
                )}

                {/* Render children comments */}
                {comment.children && comment.children.length > 0 && (
                    <div className="comment-children">
                        {comment.children.map((childComment) => renderComment(childComment, true))}
                    </div>
                )}
            </div>
        );

        return (
            <div className="comments-list">
                {comments.map((comment, i) => (
                    <>
                        {i > 0 && <Divider flexItem className="comment-divider" />}
                        {renderComment(comment)}
                    </>
                ))}
            </div>
        );
    }

    return (
        <div className="comments-section">
            <Text.h4 className="mt-3" weight={400} contrast={8} value="Comentários" icon={<CommentRounded />} />
            <AddComment replyTo={null} />
            <CommentsList />
            <Popper controlRef={popperRef} />
        </div>
    )
}
